import { ReactComponent as SortIcon } from './sort.svg';

export const GlobalAssets = {
  SortIcon,
};
